export const abilityTypes = [
  'assignments',
  'key_cooldown',
  'individual_survival',
  'individual_output',
  'individual_utility',
  'general',
] as const

export type AbilityType = typeof abilityTypes[number]

export type AbilitySpell = {
  cooldown?: number
  duration?: number
  charges?: number
  id: number
  name: string
  type: AbilityType
  talents?: AbilityTalent[]
}

export type AbilityTalent = {
  id?: number
  name?: string
  modifies?: Partial<Omit<AbilitySpell, 'talents' | 'name' | 'id' | 'type'>>
}

export type AbilitiesById = Record<string, AbilitySpell[]>

export type Abilities = {
  classSpells: AbilitiesById
  specSpells: AbilitiesById
}
